var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.list),function(i,idx){return _c('div',{key:'text-item-' + idx,class:[
			'payment-card__list-item',
			{ [i.textColor]: i.textColor }
		]},[(i.heading)?_c('h4',{staticClass:"payment-card__title"},[_vm._v(_vm._s(i.heading))]):_vm._e(),((i.title || i.text) && i.text !== null && i.text !== undefined)?_c('div',{class:[
				'payment-card__content-info',
				{ 'pb-0': _vm.isLastItem(idx) },
				{ 'payment-card__info': _vm.isHistoryType }
			]},[(i.title)?[_c('p',{staticClass:"title"},[_vm._v(_vm._s(i.title)+":")]),_c('div',{staticClass:"col"})]:_vm._e(),(i.text || i.text === 0)?_c('p',{staticClass:"text"},[_vm._v(_vm._s(i.text))]):_vm._e()],2):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }